import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { get } from '../services/api';
import Spinner from './Spinner';
import timeout from '../utils/timeout';

const MAX_ATTEMPTS = 5;
let attempts = 0;

interface StripeData {
  orderId: string;
}

interface ValidatePaymentProps {
  stripeData: StripeData;
  callback: Function;
}

function ValidatePayment({ stripeData: { orderId }, callback }: ValidatePaymentProps) {
  const { t } = useTranslation();

  const [failedValidation, setFailedValidation] = useState(null);

  useEffect(() => {
    (async () => {
      if (orderId) {
        validatePayment();
      }
    })();
  }, [orderId]);

  const validatePayment = async () => {
    attempts += 1;

    if (attempts >= MAX_ATTEMPTS) {
      setFailedValidation(
        // eslint-disable-next-line max-len
        `${t('paymentValidationFailed')} ${orderId}`
      );
    }

    await timeout(1000 * attempts);

    const { response, error } = await get(`orders/${orderId}/stripe/check`);
    if (error || !response || response.paymentStatus === 'CREATED') {
      validatePayment();
      return;
    }

    // Status can be PAID OR ERROR
    callback({ status: response.paymentStatus, payment: response });
  };

  const retryValidation = () => {
    attempts = 0;
    setFailedValidation(null);
    validatePayment();
  };

  return (
    <div className="stripe">
      {!failedValidation && (
        <div className="d-flex align-items-center m-3">
          <Spinner />
          <p className="mb-2 ml-2">{t('paymentVerification')}...</p>
        </div>
      )}
      <div className="m-3">
        {failedValidation && (
          <>
            <p className="golfamore-error">{failedValidation}</p>
            <div className="d-flex flex-row">
              <button type="button" className="button me-3" onClick={retryValidation}>
                {t('paymentVerify')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ValidatePayment;
